/* Excella — product page Add-to-Cart: AJAX add + bump the header cart counter,
   no drawer / no redirect. Runs only on product pages. Quick Buy (collection)
   is left to the theme. */
(function(){
  'use strict';
  if((window.template||'').indexOf('product')!==0) return;

  var st=document.createElement('style');
  st.textContent='.ex-atc-btn.ex-atc-added,button.AddToCart.ex-atc-added{background:#3DD27F !important;box-shadow:none !important;}';
  document.head.appendChild(st);

  function setCount(n){
    ['.CartCount','.eh-cart__count','.cart-count','[data-cart-count]'].forEach(function(s){
      document.querySelectorAll(s).forEach(function(el){
        el.textContent=n;
        if(el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', n);
      });
    });
  }
  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); })
      .catch(function(){});
  }

  document.addEventListener('submit', function(e){
    var form=e.target;
    if(!form || !form.getAttribute) return;
    if((form.getAttribute('action')||'').indexOf('/cart/add')===-1) return;
    if(form.closest && form.closest('.quickview-form')) return; /* quick buy: leave to theme */

    e.preventDefault(); e.stopImmediatePropagation();

    var btn=form.querySelector('button[name=add],#AddToCart,.ex-atc-btn,button[type=submit]');
    var lbl=btn?(btn.querySelector('#AddToCartText')||btn.querySelector('span')):null;
    var orig=lbl?lbl.textContent:'';
    if(btn) btn.disabled=true;
    if(lbl) lbl.textContent='Adding…';

    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},credentials:'same-origin',body:new FormData(form)})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if(!res.ok) throw res.j;
        refresh();
        if(btn) btn.classList.add('ex-atc-added');
        if(lbl) lbl.textContent='Added to cart ✓';
        setTimeout(function(){
          if(lbl) lbl.textContent=orig;
          if(btn){ btn.disabled=false; btn.classList.remove('ex-atc-added'); }
        }, 1800);
      })
      .catch(function(err){
        if(lbl) lbl.textContent=(err && err.description) ? 'Unavailable' : orig;
        if(btn) btn.disabled=false;
        setTimeout(function(){ if(lbl) lbl.textContent=orig; }, 2000);
      });
  }, true);
})();
